import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForbiddenComponent } from './shared/components/forbidden/forbidden.component';
import { MaintenancePageComponent } from './shared/components/maintenance-page/maintenance-page.component';
import { HealthCheckGuard } from './shared/guards/health-check.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [HealthCheckGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'faqs',
        loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
      },
      {
        path: 'contact',
        loadChildren: () => import('./contact/contact.module').then((m) => m.ContactModule),
      },
      {
        path: 'employee-details',
        loadChildren: () => import('./employee-details/employee-details.module').then(
          (m) => m.EmployeeDetailsModule
        ),
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'content/team/:language/home/forms/:dynamicSection',
        redirectTo: 'employee-details',
      },
      {
        path: 'forbidden',
        component: ForbiddenComponent,
      },
      {
        path: 'faqs.html',
        redirectTo: 'faqs',
      },
      {
        path: 'contact.html',
        redirectTo: 'contact',
      },
      {
        path: 'forms/:group/contact.html',
        redirectTo: 'contact',
      },
      {
        path: 'employee-details.html',
        redirectTo: 'employee-details',
      },
      {
        path: 'forms/:group/employee-details.html',
        redirectTo: 'employee-details',
      },
      {
        path: 'internal/login.html',
        redirectTo: 'admin/login',
      },
      {
        path: 'internal/login.html/list',
        redirectTo: 'admin',
      },
      {
        path: 'forms/ea-remediation.html',
        redirectTo: 'employee-details',
        pathMatch: 'full',
      },
      {
        path: 'employee-details.html',
        redirectTo: 'employee-details',
        pathMatch: 'full',
      },
      {
        path: 'forms/induction-details.html',
        redirectTo: 'employee-details',
        pathMatch: 'full',
      },
      {
        path: 'forms/working-across-brands.html',
        redirectTo: 'employee-details',
        pathMatch: 'full',
      },
      {
        path: 'forms/longservice-leave.html',
        redirectTo: 'employee-details',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: '',
      }
    ],
  },
  {
    path: 'maintenance',
    component: MaintenancePageComponent,
    title: 'Maintenance',
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
